module.exports = __webpack_public_path__ + "71f0abf979b3862ba2c73960e2c6c5d5.jpg";